function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "my vector image");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#cd853f",
  fillOpacity: 1,
  stroke: "#222222",
  strokeOpacity: 1,
  strokeWidth: 2,
  strokeDasharray: "none",
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  strokeDashoffset: "",
  fillRule: "nonzero",
  opacity: 1,
  markerStart: "",
  markerMid: "",
  markerEnd: "",
  d: "M1.1452991366386414,10.726495683193207 C1.1452991366386414,7.411578556121384 8.529277037191127,4.726495683193207 17.64529913663864,4.726495683193207 C26.761321236086154,4.726495683193207 34.14529913663864,7.411578556121384 34.14529913663864,10.726495683193207 C34.14529913663864,14.04141281026503 26.761321236086154,16.726495683193207 17.64529913663864,16.726495683193207 C8.529277037191127,16.726495683193207 1.1452991366386414,14.04141281026503 1.1452991366386414,10.726495683193207 z",
  id: "svg_10",
  className: ""
});

var SvgBakedBiscuit = function SvgBakedBiscuit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    className: "baked-biscuit-svg",
    style: {},
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    className: "currentLayer"
  }, _ref3, /*#__PURE__*/React.createElement("path", {
    fill: "#dadada",
    fillOpacity: 1,
    stroke: "#222222",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_4",
    d: "M101.97224869051944,186.3555011839844 ",
    style: {
      color: "rgb(210, 180, 140)"
    },
    className: ""
  }), _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBakedBiscuit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baked-biscuit.d6e5c460.svg";
export { ForwardRef as ReactComponent };